import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  /**
   * Writes the text to the system clipboard. iOS only allows this while handling a user gesture,
   * so call it synchronously from the tap that triggered it.
   */
  copyText$(text: string): Promise<void> {
    return navigator.clipboard.writeText(text);
  }
}
